import BaseForm from '@js/forms/base-form'
import { isObject } from '@js/data-utils'
import { normalizeSkillName } from '@js/str-utils'

class FormTenantUserSkill extends BaseForm {
  static getDataTemplate () {
    return {
      periodCategoryId: null,
      skillName: '',
      skillStatusTypeId: null,
      targetIds: [],
    };
  }
  constructor () {
    super();
    this.params.id = null;
  }
  getTargetIds (tenantUserSkill) {
    if (tenantUserSkill.targets == null) {
      return [];
    }
    return tenantUserSkill.targets;
  }
  getSkillStatusTypeId (tenantUserSkill) {
    if (tenantUserSkill.skillStatusType == null) {
      return null;
    }
    return tenantUserSkill.skillStatusType.id;
  }
  getPeriodCategoryId (tenantUserSkill) {
    if (tenantUserSkill.experiencePeriodCategory == null) {
      return null;
    }
    return tenantUserSkill.experiencePeriodCategory.id;
  }
  getPostPayload () {
    return {
      experienceTypeId: null,
      experiencePeriodCategoryId: this.data.periodCategoryId,
      jobCategoryId: null,
      skillId: null,
      skillName: normalizeSkillName(this.data.skillName),
      skillStatusTypeId: this.data.skillStatusTypeId,
      targetIds: this.data.targetIds,
    };
  }
  getPutPayload () {
    return {
      targetIds: this.data.targetIds,
      experiencePeriodCategoryId: this.data.periodCategoryId,
      skillStatusTypeId: this.data.skillStatusTypeId,
    };
  }
  set (tenantUserSkill) {
    if (!isObject(tenantUserSkill)) {
      this.clear();
    }

    this.params.id = tenantUserSkill.id;
    this.data.targetIds = this.getTargetIds(tenantUserSkill);
    this.data.skillStatusTypeId = this.getSkillStatusTypeId(tenantUserSkill);
    this.data.periodCategoryId = this.getPeriodCategoryId(tenantUserSkill);
    this.data.skillName = tenantUserSkill.skill.name;
  }
}

export {
  FormTenantUserSkill,
};
